
import React from 'react';
import { MockGooglePlace } from '@/utils/mockGoogleMapsApi';
import { Loader2 } from 'lucide-react';

interface SearchResultsListProps {
  searchResults: MockGooglePlace[];
  isLoading: boolean;
  isSearching: boolean;
  usingMockData: boolean;
  onSelectBusiness: (business: MockGooglePlace) => void;
}

const SearchResultsList: React.FC<SearchResultsListProps> = ({
  searchResults,
  isLoading,
  isSearching,
  usingMockData,
  onSelectBusiness
}) => {
  if (isLoading || isSearching) {
    return (
      <div className="flex items-center justify-center p-4">
        <Loader2 className="h-4 w-4 animate-spin mr-2" />
        <span>Searching...</span>
      </div>
    );
  }

  if (searchResults.length === 0) {
    return (
      <div className="p-2 text-xs text-gray-500">
        No results found. Click "Create New" to add it.
      </div>
    );
  }

  return (
    <>
      <div className="p-2 text-xs text-gray-500 border-b flex items-center justify-between">
        <span>Select an existing business</span>
        {usingMockData && <span className="text-yellow-600 text-xs">(Sample data)</span>}
      </div>
      {searchResults.map((business) => (
        <div 
          key={business.place_id}
          className="p-2 hover:bg-gray-50 cursor-pointer"
          onClick={() => onSelectBusiness(business)}
        >
          <div className="font-medium">{business.name}</div>
          <div className="text-xs text-gray-500">{business.formatted_address}</div>
        </div>
      ))}
    </>
  );
};

export default SearchResultsList;
